module.exports = __webpack_public_path__ + "img/subheader02.c949686f.jpg";